<template>
  <svg
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.51 421.4V228.14H119.42V262.36C119.42 266.47 122.75 269.79 126.85 269.79H143.2V470.38
      H126.85C122.75 470.38 119.42 473.71 119.42 477.81V497.13H28.51V421.4ZM315.39 120.48L389.1
      170.71H123.41L255.57 81.48C255.83 81.51 256.1 81.53 256.37 81.53C256.56 81.53 256.74 81.51
      256.92 81.5L282.8 98.47L315.39 120.48ZM290.96 86.04L263.8 68.23V51.18C265.13 51.34 266.45
      51.42 267.75 51.42C279.83 51.42 295.32 40.88 306.73 47.46C311.54 50.23 317.87 46.61 317.87
      41.02V12.18C317.87 9.52 316.45 7.07 314.15 5.74C305.71 0.88 296.4 1.26 287.23 3.42C279.82
      5.18 271.55 9.26 263.8 7.26C263.27 -2.19 248.94 -2.6 248.94 7.12V68.03L168.77 122.16H99.23C97.67
      122.16 96.14 122.66 94.87 123.57L30.46 170.14C30.2 170.33 29.96 170.54 29.73 170.75H9.43C5.32
      170.75 2 174.08 2 178.18V220.71C2 224.82 5.33 228.14 9.43 228.14H13.64V504.57C13.64 508.67
      16.96 512 21.07 512H491.25C502.6 512 498.68 487.11 498.68 480.48V236.12C498.68 233 496.79
      226.52 501.9 228.14C506.01 228.14 509.33 224.81 509.33 220.71V178.18C509.33 174.07 506.01
      170.75 501.9 170.75H482.58C482.35 170.54 482.11 170.33 481.85 170.14L417.44 123.57C416.17
      122.65 414.65 122.16 413.08 122.16H344.23L323.75 108.2L290.94 86.05L290.96 86.04ZM263.8
      22.35C271.62 23.31 279.07 21.16 285.46 19.32C292.84 17.19 298.15 15.83 303.01 17.08V30.85C295.19
      29.89 287.74 32.04 281.35 33.88C273.97 36 268.66 37.37 263.8 36.11V22.35ZM366.06 137.02H410.69
      L457.34 170.75H415.55L366.05 137.02H366.06ZM101.64 137.02H146.75L96.79 170.75H54.99L101.64
      137.02ZM195.72 497.14H134.29V485.25H195.72V497.14ZM158.07 470.38V271.77H172.93V470.38H158.07ZM273.01
      494.73H239.32V408.3C239.32 403.37 241.46 398.71 245.2 395.51C251.55 390.07 260.77 390.06 267.13
      395.51C270.86 398.72 273.01 403.38 273.01 408.3V494.73ZM273.01 254.93H134.29V228.18H378.05V254.93
      H273.01ZM312.64 269.8H325.52V470.39H309.17C305.06 470.39 301.74 473.72 301.74 477.82V497.14H287.86
      V408.3C287.86 399.03 283.82 390.26 276.79 384.23C264.83 373.98 247.47 373.98 235.52 384.23C228.48
      390.26 224.45 399.03 224.45 408.3V497.14H210.57V477.82C210.57 473.72 207.24 470.39 203.14 470.39H187.78
      V269.8H312.63H312.64ZM355.25 271.78V470.39H340.39V271.78H355.25ZM378.04 497.14H316.61V485.25H378.04
      V497.14ZM483.82 497.14H392.91V477.82C392.91 473.72 389.59 470.39 385.48 470.39H370.12V269.8H385.48C389.59
      269.8 392.91 266.47 392.91 262.37V228.14H483.82V497.14ZM494.47 213.27H16.86V185.61H494.47V213.27Z"
      fill="currentColor"
    />
    <path
      d="M256.16 291.59C240.04 291.59 226.93 304.7 226.93 320.82C226.93 336.94 240.04 350.05 256.16
      350.05C272.28 350.05 285.39 336.94 285.39 320.82C285.39 304.7 272.28 291.59 256.16 291.59ZM256.16
      335.2C248.24 335.2 241.79 328.75 241.79 320.83C241.79 312.91 248.24 306.46 256.16 306.46C264.08
      306.46 270.53 312.91 270.53 320.83C270.53 328.75 264.08 335.2 256.16 335.2Z"
      fill="currentColor"
    />
    <path
      d="M413.14 352H440.06C444.17 352 447.49 348.67 447.49 344.57V290.35C447.49 278.83 438.12 269.46 426.6
      269.46C415.08 269.46 405.71 278.83 405.71 290.35V344.57C405.71 348.68 409.03 352 413.14 352ZM420.57
      290.34C420.57 287.02 423.27 284.31 426.6 284.31C429.93 284.31 432.63 287.01 432.63 290.34V337.13H420.58
      V290.34H420.57Z"
      fill="currentColor"
    />
    <path
      d="M413.14 460H440.06C444.17 460 447.49 456.67 447.49 452.57V398.35C447.49 386.83 438.12 377.46 426.6
      377.46C415.08 377.46 405.71 386.83 405.71 398.35V452.57C405.71 456.68 409.03 460 413.14 460ZM420.57
      398.35C420.57 395.03 423.27 392.32 426.6 392.32C429.93 392.32 432.63 395.02 432.63 398.35V445.14H420.58
      V398.35H420.57Z"
      fill="currentColor"
    />
    <path
      d="M97.21 352C101.32 352 104.64 348.67 104.64 344.57V290.35C104.64 278.83 95.27 269.46 83.75 269.46C72.23
      269.46 62.86 278.83 62.86 290.35V344.57C62.86 348.68 66.19 352 70.29 352H97.21ZM77.72 290.34C77.72
      287.02 80.42 284.31 83.75 284.31C87.08 284.31 89.78 287.01 89.78 290.34V337.13H77.73V290.34H77.72Z"
      fill="currentColor"
    />
    <path
      d="M62.86 452.57C62.86 456.68 66.19 460 70.29 460H97.21C101.32 460 104.64 456.67 104.64 452.57V398.35C104.64
      386.83 95.27 377.46 83.75 377.46C72.23 377.46 62.86 386.83 62.86 398.35V452.57ZM77.72 398.35C77.72
      395.03 80.42 392.32 83.75 392.32C87.08 392.32 89.78 395.02 89.78 398.35V445.14H77.73V398.35H77.72Z"
      fill="currentColor"
    />
  </svg>
</template>
